export const STREAM_DASHBOARD_ROUTES = {
    COURSE_TITLE_STREAM: { path: '/course/:courseTitle/:streamId' },
    COURSE_STREAM: { path: '/course/:streamId' },
    STREAM_COMPLETED: { path: '/course/:streamId/completed' },
};
